import { SingleStatusGroup, StatusGroups } from '@/routes/settings/statuses/types/status.ts'
import { create } from 'zustand'

const EMPTY_STATUS_GROUP: SingleStatusGroup = {
  name: undefined!,
  description: '',
  statuses: [],
  id: undefined!,
}

export type StatusGroupsState = {
  statusGroups: StatusGroups | null
  setStatusGroups: (statusGroups: StatusGroups | null) => void
  addNewStatusGroup: () => void
  changeLastStatusGroup: (statusGroup: SingleStatusGroup) => void
  deleteLastLabelGroup: () => void
  currentlyEditedStatusId: number | null
  setCurrentlyEditedStatusId: (id: number | null) => void
}

export const useAllStatusGroupStore = create<StatusGroupsState>((set, get) => ({
  statusGroups: null,
  setStatusGroups: statusGroups => {
    set({
      statusGroups,
    })
  },
  addNewStatusGroup: () => {
    const { statusGroups } = get()
    const members = statusGroups?.['hydra:member'] || []
    if (members.length === 0 || members[members.length - 1].id !== undefined) {
      const newMembers = [...members, { ...EMPTY_STATUS_GROUP }]
      set({
        statusGroups: {
          ...statusGroups,
          'hydra:member': newMembers,
        },
      })
    }
  },
  changeLastStatusGroup: (statusGroup: SingleStatusGroup) => {
    const { statusGroups } = get()
    const members = statusGroups?.['hydra:member'] || []
    if (members.length === 0) return

    const newMembers = [...members.slice(0, -1), statusGroup]

    set({
      statusGroups: {
        ...statusGroups,
        'hydra:member': newMembers,
      },
    })
  },
  deleteLastLabelGroup: () => {
    const { statusGroups } = get()
    const members = statusGroups?.['hydra:member'] || []
    if (members.length === 0) return

    const newMembers = members.slice(0, -1)

    set({
      statusGroups: {
        ...statusGroups,
        'hydra:member': newMembers,
      },
    })
  },
  currentlyEditedStatusId: null,
  setCurrentlyEditedStatusId: id => set({ currentlyEditedStatusId: id }),
}))
